import * as cqs from '@/lib/cqs'
import { getCommandDispatcher, getQueryExecutor } from './compose'

export function createCqsChannel(t: ITrelloClient ,baseUrl: string) {
    return new cqs.Channel(
        getCommandDispatcher(t,baseUrl),
        getQueryExecutor(t,baseUrl))
    .withDefaultRequestType(cqs.RequestType.Queued);
}
//@ts-ignore
export var channel = function(t: any): cqs.IChannel { return createCqsChannel(t,process.env.APPLICATION_API_ROOT); }
export default channel;

